<template lang="pug">
pr-wrapper.sideload.animated(fs, bg, bgo=".5", :zi="index", nv-sleep-protect, v-visible="activated")
  imagec.mr-3(:src="background", v-if="background")
  pr-wrapper.sideload-container.animated.d-flex.flex-column.justify-content-center(fs, bg, zi="1", :class="position")
    pr-wrapper.preloader(bg, bgo=".9", v-show="!ready")
      icon.fa-spin(:icon="'fas spinner'")
    component(
      v-bind:is="currentComponent",
      @close="close",
      @ready="ready = true",
      @background="background = $event",
      v-nv:scope="'sideload'",
      nv-exit-protect,
      @nv-back.native="close",
      @nv-exit.native="close"
    )
</template>

<script>
import billview from "@/views/sideloads/billview/billview.vue"
import bluetooth from "@/views/sideloads/bluetooth.vue"
import cart from "@/views/sideloads/cart.vue"
import internet from "@/views/sideloads/internet.vue"
import mobile from "@/views/sideloads/mobile.vue"

export default {
  name: "sideload",
  components: { billview, bluetooth, cart, internet, mobile },
  data() {
    return {
      background: null,
      ready: false,
      currentComponent: null,
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  computed: {
    position() {
      return {
        left: this.payload.position === "left",
        right: this.payload.position === "right",
        activated: this.activated
      }
    }
  },
  watch: {
    currentComponent() {
      this.background = null
      this.ready = false
    },
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "100" : "0"
    }
  },
  mounted() {
    _$.vue.$on("sideload", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()
      if (!this.validatePayload(payload)) return false
      if (this.activated) this.payload.reject()

      this.payload = payload
      if (this.currentComponent === payload.component) {
        this.currentComponent = null
      }
      await this.$nextTick()
      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }
      this.currentComponent = payload.component
      this.activated = true
    },
    validatePayload(payload) {
      let validate = true

      if (typeof payload !== "object") validate = false
      else if (!payload.component || !payload.position || !payload.params) validate = false
      else if (typeof payload.resolve !== "function") validate = false
      else if (typeof payload.reject !== "function") validate = false
      else if (!this.$options.components[payload.component]) validate = false

      if (!validate && typeof payload === "object" && payload.reject) payload.reject()

      return validate
    },
    close(reason, resolve) {
      if (!this.activated) return false
      this.currentComponent = null

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (resolve) this.payload.resolve(resolve)
      else this.payload.reject()

      this.payload = {}

      if (resolve) return resolve
      else return false
    }
  }
}
</script>

<style lang="scss" scoped>
.sideload-container {
  box-shadow: 10px 0px 15px 2px rgba(0, 0, 0, 0.5);
  position: absolute;
  min-width: 300px;
  .preloader {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
  &.left {
    transform: translate(-100%, 0);
    right: auto !important;
    &.activated {
      transform: translate(0%, 0%);
    }
  }

  &.right {
    box-shadow: -10px 0px 15px 2px rgba(0, 0, 0, 0.5);
    transform: translate(100%, 0);
    left: auto !important;
    &.activated {
      transform: translate(0%, 0%);
    }
  }
}
</style>
